module.exports = __webpack_public_path__ + "img/insta10.223ab6c7.jpg";